<template>
  <div class="pe-site-plan-design-add">
    <slot :show="show"></slot>
    <DataGridDialog title="添加年级方案"
                    width="360px"
                    :visible.sync="visible"
                    @open="handleOpen">
      <div class="pe-site-plan-design-add-wrap"
           v-loading="loading"
           element-loading-text="加载中...">
        <div class="body"
             v-loading="committing"
             element-loading-text="提交中，请稍等...">
          <el-form size="mini"
                   label-width="90px">
            <el-form-item label="选择初始年级">
              <el-select v-model="form.sinceGradeId"
                         size="mini"
                         filterable>
                <template v-if="grades">
                  <el-option v-for="grade in grades"
                             :key="grade.id"
                             :label="grade.name"
                             :value="grade.id"/>
                </template>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">添加</el-button>
          <el-button size="mini"
                     type="default"
                     @click="hide">取消</el-button>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
export default {
  name: 'PeSitePlanDesignAdd',
  components: {
    DataGridDialog
  },
  props: {
    siteId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      grades: null,
      form: {
        sinceGradeId: ''
      },
      committing: false
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    loadGrades () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/grades',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.grades = response.data['grades'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleOpen () {
      Object.keys(this.form).forEach(key => {
        this.form[key] = ''
      })
      this.loadGrades()
    },
    handleApply () {
      if (!this.form.sinceGradeId) {
        this.$message.warning('请选择初始年级')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/basic/peSite/plan/add',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.siteId
        }, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.hide()
              this.$nextTick(() => {
                this.$emit('add-success')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  }
}
</script>

<style lang="scss">
  .pe-site-plan-design-add {
    display: inline-block;
  }
  .pe-site-plan-design-add-wrap {
    & > .body {
      padding: 20px 30px 20px 15px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
